import type { I18nLocale } from "@/modules/i18n/types"

export const getActiveHrefs = (locale: I18nLocale): string[] => {
  const features = ["v2/appointments", "toolbox", "job-roles", "advices", "handbook", "insights", "career-service"]
  return features.map(feature => `/${locale}/${feature}`)
}

export const getStudentActiveHrefs = (locale: I18nLocale): string[] => {
  const features = [
    "my-profile",
    "my-profile/edit/personal-information",
    "my-profile/edit/cv",
    "my-profile/edit/job-preferences",
    "my-profile/edit/languages",
    "my-profile/edit/education",
    "my-profile/edit/work-experiences",
    "my-profile/edit/other-experiences",
    "dashboard/my_saved_search",
    "dashboard/my_job_offers",
    "dashboard/my_applications",
    "dashboard/my_events",
    "dashboard/my_appointments",
  ]
  return features.map(feature => `/${locale}/${feature}`)
}
